<template>
    <v-dialog
            :value="!!value"
            :retain-focus="false"
            persistent
            max-width="800"
    >
        <v-form
                v-model="validForm"
                ref="form"
                @submit.prevent="submit"
        >
            <v-card
                    :loading="loading > 0"
                    :disabled="loading > 0"
            >
                <v-card-title class="grs-card-title px-0">
                    <span v-if="!value.id"> {{ $t('create_fax_channel_form_title') }} </span>
                    <span v-else> {{ $t('update_fax_channel_form_title') }} </span>

                    <v-spacer></v-spacer>

                    <v-btn
                            text
                            small
                            icon
                            @click="$emit('close')"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-text-field
                            v-model="value.name"
                            :rules="[rules.required]"
                            :label="$t('name')"
                    ></v-text-field>
                    <v-select
                            v-model="value.class_name"
                            :label="$t('fax_channel_class_name')"
                            :items="['Simotel','SimotelV3']"
                            :rules="[rules.required]"
                            class="ltr"
                    ></v-select>
                    <template v-if="value.class_name == 'Simotel' || value.class_name == 'SimotelV3'">
                        <v-text-field
                                placeholder="https://example.com"
                                v-model="value.data.host"
                                :label="$t('host')"
                                :rules="[rules.required]"
                                class="ltr"
                        ></v-text-field>
                        <v-text-field
                                v-model="value.data.username"
                                :label="$t('username')"
                                :rules="[rules.required]"
                                class="ltr"
                        ></v-text-field>
                        <v-text-field
                                v-model="value.data.password"
                                :label="$t('password')"
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="showPass ? 'text' : 'password'"
                                name="input-10-2"
                                hint="At least 8 characters"
                                value="wqfasds"
                                class="input-group--focused ltr"
                                @click:append="showPass = !showPass"
                        ></v-text-field>
                        <v-text-field
                                v-model="value.data.trunk_name"
                                :label="$t('trunk_name')"
                                class="ltr"
                        ></v-text-field>
                    </template>
                    <v-textarea
                            v-model="value.description"
                            :label="$t('description')"
                    ></v-textarea>
                </v-card-text>

                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>

                    <v-btn
                            color="secondary"
                            text
                            class="px-4"
                            @click="$emit('close')"
                    >{{$t('cancel')}}</v-btn>

                    <v-btn
                            color="primary"
                            class="px-4"
                            type="submit"
                    >
                        {{$t('send_request')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    import { required, mobile, password } from '@/scripts/validationRules';
    import Service from "../services/FaxChannelsService";

    export default {
        props: {
            item : {
                required: true
            }
        },
        computed : {
        },
        data() {
            return {
                validForm: false,
                loading: 0,
                showPass : false,
                value : {...this.item},
                rules: {
                    required,
                    mobile,
                    password
                },

            }
        },
        watch : {
            'value.class_name' : (value) =>{
                switch (value){
                    case 'Simotel':
                        this.value.data = Service.getSimotelDataDefault();
                    break;
                }
            }
        },
        created(){

        },
        methods: {

            async submit() {
                if(!this.validForm) {
                    return this.$refs.form.validate();
                }

                try {
                    this.loading++;

                    let {
                        data
                    } = this.value.id ? await Service.update(this.value) : await Service.create(this.value);
                    this.$emit('submit', data);

                    this.$notify({
                        group: 'formGroup',
                        type: 'success',
                        title: data.message,
                    });

                } finally {
                    this.loading--;
                }

                this.$emit('close');
            }
        }
    }
</script>